import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './NearbyStores';

const NearbyStoresSuspense = dynamic(() => import('./NearbyStores'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicNearbyStores(props: Props) {
	return <NearbyStoresSuspense {...props} />;
}
DynamicNearbyStores.displayName = 'DynamicNearbyStores';
